import React, { FC } from 'react';

interface TabPanelProps {
  index: number;
  value: number;
}

export const TabPanel: FC<TabPanelProps> = ({ children, value, index, ...other }) => {
  return (
    <div
      className="tab-panel"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <div className="tab-panel__tabs-container">{children}</div>}
    </div>
  );
};
